import { computed, type Ref } from 'vue';
import { useElementBounding } from '@vueuse/core';

export function useElementPosition(elementRef: Ref<HTMLElement | null | undefined>) {
    const { height, width, x, y } = useElementBounding(elementRef);

    const style = computed(() => {
        return {
            top: `${y.value + height.value + 10}px`,
            left: `${x.value + width.value / 2}px`,
            transform: 'translateX(-50%)',
        };
    });

    return { style };
}
